(function($, Drupal, drupalSettings) {

  var mouseOnNavTimer = false;
  var mouseOnNavTop = false;
  var mouseOnNavDropdown = false;

  var scrollPosition = 0;

  var toolbarsHeightInView = 0;

  Drupal.behaviors.mbo_nav_001 = {
    attach: function (context, settings) {

      // ---------------------------------------------------------------------
      // ------------------------- Desktop dropdown --------------------------

      // Open dropdown.
      function openDropdown(item) {
        // Add class for hover styling.
        $('.mbo-nav-001-botttom ul.menu li a,.mbo-nav-001-botttom ul.menu li span').removeClass('hover');
        $(item).addClass('hover');

        // Set hovering top level.
        $('.mbo-nav-001-botttom ul.menu').addClass('hovering');

        // Regular link so close dropdown.
        if (!$(item).closest('li').hasClass('menu-item--collapsed')) {
          closeDropdown(true);
          return true;
        }

        // Set available height for css scrolling.
        getDropdownAvailableHeight();

        // Get index to set active and show relevant dropdown.
        var itemN = $('> li', $(item).closest('ul.menu')).index($(item).closest('li'));

        // Set the active top level.
        $('.mbo-nav-001-botttom ul.menu li').removeClass('open');
        $(item).closest('li').addClass('open');

        // If dropdown not already open, stop size and position transition.
        if (!$('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').hasClass('open')) {
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').addClass('noSlideResize');
          $('.mbo-nav-001-dropdowns > .mbo-nav-001-dropdown-arrow').addClass('noSlideResize');
          setTimeout(function () {
            $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').removeClass('noSlideResize');
            $('.mbo-nav-001-dropdowns > .mbo-nav-001-dropdown-arrow').removeClass('noSlideResize');
          }, 100);
        }

        // Calculate left offset of top level link center.
        var linkCenterOffset = $(item).offset().left + ($(item).outerWidth() / 2);

        // Calculate container and page width.
        var containerWidth = $('.mbo-nav-001-botttom > .container').width();
        var pageWidth = $(window).width();

        // Calculate left offsets of the container.
        var containerOffset = $('.mbo-nav-001-botttom > .container').offset().left + 15;
        var containerEndOffset = $('.mbo-nav-001-botttom > .container').offset().left + containerWidth + 15;

        // Calculate the required dropdown position.
        var dropBorderPad = 2;
        var dropdownItemWidth = $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:eq(' + itemN + ')').outerWidth() + dropBorderPad;
        if ((linkCenterOffset - (dropdownItemWidth / 2)) > 15 &&
            (linkCenterOffset + (dropdownItemWidth / 2)) < (pageWidth - 15)) {
          // Center under link.
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').css('left', linkCenterOffset + 'px');
        }
        else if ((linkCenterOffset - (dropdownItemWidth / 2)) < 15 &&
                 (containerOffset + dropdownItemWidth) < (pageWidth - 15)) {
          // Align left of the container.
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').css('left', (containerOffset + (dropdownItemWidth / 2)) + 'px');
        }
        else if ((linkCenterOffset + (dropdownItemWidth / 2)) > pageWidth &&
                 (containerEndOffset - dropdownItemWidth) > 15) {
          // Align right of the container.
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').css('left', (containerEndOffset - (dropdownItemWidth / 2)) + 'px');
        }
        else {
          // Set dropdown width to match the container.
          $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:eq(' + itemN + ')').css('width', (containerWidth) + 'px');
          dropdownItemWidth = $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:eq(' + itemN + ')').outerWidth() + dropBorderPad;

          // Align left of the container.
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').css('left', (containerOffset + (dropdownItemWidth / 2)) + 'px');
        }

        // Set the arrow pointer position.
        $('.mbo-nav-001-dropdowns > .mbo-nav-001-dropdown-arrow').css('left', linkCenterOffset + 'px');

        // Calculate the required dropdown size.
        var dropDownHeight = $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:eq(' + itemN + ')').actual('outerHeight');
        var dropDownWidth = $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:eq(' + itemN + ')').actual('outerWidth');
        $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').css('height', (dropDownHeight + dropBorderPad) + 'px').css('width', (dropDownWidth + dropBorderPad) + 'px');

        // Set the active dropdown item.
        $('.mbo-nav-001-dropdowns nav.menu--main > ul > li').removeClass('open');
        if ($('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').hasClass('noSlideResize')) {
          $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:eq(' + itemN + ')').addClass('open').show();
          $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:not(.open)').hide();
        } else {
          $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:eq(' + itemN + ')').addClass('open').stop(true, true).fadeIn(400);
          $('.mbo-nav-001-dropdowns nav.menu--main > ul > li:not(.open)').stop(true, true).fadeOut(400);
        }

        // Show the dropdown and arrow, if not showing already.
        $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').addClass('open').addClass('open-swing').removeClass('close-swing');
        $('.mbo-nav-001-dropdowns > .mbo-nav-001-dropdown-arrow').addClass('open');
        $('.mbo-nav-001-dropdowns').addClass('open');

        // Close other nav if its open.
        if (typeof Drupal.mbo_nav_002 != 'undefined' &&
            typeof Drupal.mbo_nav_002.closeDropdown == 'function') {
          Drupal.mbo_nav_002.closeDropdown();
        }
      }

      // Close dropdown.
      function closeDropdown(stillHovering) {
        // Remove class for hover styling.
        $('.mbo-nav-001-botttom ul.menu li a,.mbo-nav-001-botttom ul.menu li span').removeClass('hover');

        // Unset hovering top level.
        if (!stillHovering) {
          $('.mbo-nav-001-botttom ul.menu').removeClass('hovering');
        }

        // Unset the active top level.
        $('.mbo-nav-001-botttom ul.menu li').removeClass('open');

        // Hide the dropdown.
        $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').removeClass('open');
        $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').addClass('close-swing');
        mouseOnNavTimer = setTimeout(function () {
          if (!$('.mbo-nav-001-botttom ul.menu').hasClass('hovering')) {
            $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').removeClass('open-swing').removeClass('close-swing');
            $('.mbo-nav-001-dropdowns').removeClass('open');
          }
        }, 400);

        // Close the dropdown item and hide the arrow.
        $('.mbo-nav-001-dropdowns > .mbo-nav-001-dropdown-arrow').removeClass('open');
        $('.mbo-nav-001-dropdowns nav.menu--main > ul > li').removeClass('open');
      }

      // Calculate dropdowns natural widths.
      function calculateDropdownWidths() {
        if (!$('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').hasClass('open')) {
          // Reset widths.
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').css('width', '');
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns nav.menu--main > ul.menu > li').show().css('width', '');
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns nav.menu--main > ul.menu > li > ul.menu-related .related-item').css('width', '');

          // Set related columns to columns above.
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns nav.menu--main > ul.menu > li > ul.menu-related').each(function(index, value){
            if ($('.related-item', value).length > 1) {
              // Get widths of the columns.
              var colWidths = [];
              $('.related-item', value).each(function (relIndex, relValue) {
                colWidths.push($('> li:eq(' + relIndex + ')', $(relValue).closest('ul.menu-related.column-levels').prev('ul.menu.column-levels')).outerWidth());
              });

              // Apply widths of the columns
              $('.related-item', value).each(function (relIndex, relValue) {
                $(relValue).css('width',  colWidths[relIndex] + 'px');
              });
            }
          });

          // Set each dropdown width.
          setTimeout(function () {
            $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns nav.menu--main > ul.menu > li').each(function (index, value) {
              $(value).css('width', $(value).actual('outerWidth'));
            });
          }, 100);
        }
      }

      function getDropdownAvailableHeight() {
        document.documentElement.style.setProperty( '--mbo-nav-001-dropheight', $(window).outerHeight() - ($('.mbo-nav-001-botttom').offset().top - $(window).scrollTop()) + 'px');
      }

      // ---------------------------------------------------------------------
      // ---------------------------- Mobile nav -----------------------------

      // Open mobile menu.
      function openMobileMenu() {
        // Change the toggle status.
        $('.mbo-nav-001-mobile-toggle').addClass('open');

        // Reset levels to initial.
        $('.field--name-field-o-nav-main-menu-mobile nav.menu--main div.ul-menu-wrapper').removeClass('open');
        $('.field--name-field-o-nav-main-menu-mobile nav.menu--main div.ul-menu-wrapper.top').addClass('open').addClass('current');

        // Set toolbars and footer contacts height.
        getToolbarsHeight();
        getFooterItemsHeight();
        getEyebrowMiddleItemsHeight();

        // Slide in.
        $('.mbo-nav-001-mobile-wrapper').addClass('open');
        $('.mbo_hero_001--mbo_nav_001--header-hybrid').addClass('opened');

        // Lock page scroll.
        $.scrollLock(true);
      }

      // Close mobile menu.
      function closeMobileMenu() {
        // Change the toggle status.
        $('.mbo-nav-001-mobile-toggle').removeClass('open');

        // Slide out.
        $('.mbo-nav-001-mobile-wrapper').removeClass('open');
        $('.mbo_hero_001--mbo_nav_001--header-hybrid').removeClass('opened');

        // Unlock page scroll.
        setTimeout(function(){
          $.scrollLock(false);
        }, 300);
      }

      // Open next menu.
      function nextMobileMenu(item) {
        // Remove current and stop scroll of other levels.
        $('.field--name-field-o-nav-main-menu-mobile nav.menu--main div.ul-menu-wrapper').removeClass('current');

        // Open next level and enable scrolling.
        $('.field--name-field-o-nav-main-menu-mobile nav.menu--main div.ul-menu-wrapper[data-menu="' + $(item).closest('li').data('menu') + '"]').addClass('open').addClass('current');
      }

      // Close current menu.
      function prevMobileMenu(item) {
        // Remove open and disable scrolling.
        $(item).closest('div.ul-menu-wrapper').addClass('closing').removeClass('open');

        // Reset scroll to the previous level.
        $($(item).closest('div.ul-menu-wrapper')).closest('div.ul-menu-wrapper').addClass('current');

        // Remove closing class to reset z-index.
        setTimeout(function(){
          $('.field--name-field-o-nav-main-menu-mobile nav.menu--main div.ul-menu-wrapper').removeClass('closing');
        }, 500);
      }

      // Work out toolbar heights and if they're in view.
      function getToolbarsHeight() {
        // Work out toolbar heights and if they're in view.
        var toolbarsHeight = 0;
        if ($('body').hasClass('user-logged-in') && ($('body').hasClass('toolbar-fixed') || $(window).scrollTop() == 0)) {
          if ($('#toolbar-administration > #toolbar-bar').length) {
            toolbarsHeight += $('#toolbar-administration > #toolbar-bar').outerHeight();
          }
          if ($('#toolbar-item-administration-tray.toolbar-tray-horizontal').length && $('#toolbar-item-administration-tray.toolbar-tray-horizontal').is(':visible')) {
            toolbarsHeight += $('#toolbar-item-administration-tray').outerHeight();
          }
          if ($('.region-local-tasks').length) {
            toolbarsHeight +=  $('.region-local-tasks').outerHeight();
          }
        }

        document.documentElement.style.setProperty( '--mbo-nav-001-toolbars-height-inview', Math.floor(toolbarsHeight) + 'px' );
        return Math.floor(toolbarsHeight);
      }

      function getFooterItemsHeight() {
        var mboNav001CFoot = 0;
        if ($('.field--name-field-o-nav-middle-block-mobile').length) {
          mboNav001CFoot += $('.field--name-field-o-nav-middle-block-mobile').actual('outerHeight');
        }
        if ($('.field--name-field-o-nav-middle-menu-mobile').length) {
          mboNav001CFoot += $('.field--name-field-o-nav-middle-menu-mobile').actual('outerHeight');
        }
        document.documentElement.style.setProperty( '--mbo-nav-001-cfoot', mboNav001CFoot + 'px' );
      }

      function getEyebrowMiddleItemsHeight() {
        var mboNav001CEyebrow = 0;
        var mboNav001CMiddle = 0;
        if ($('.field--name-field-o-nav-top-menu-mobile').length && $('.field--name-field-o-nav-top-menu-mobile').is(':visible')) {
          mboNav001CEyebrow += $('.field--name-field-o-nav-top-menu-mobile').actual('outerHeight');
        }
        if ($('.mbo-nav-001-top').length && $('.mbo-nav-001-top').is(':visible')) {
          mboNav001CMiddle += $('.mbo-nav-001-top').actual('outerHeight');
        } else if ($('.mbo-nav-001-middle').length && $('.mbo-nav-001-middle').is(':visible')) {
          mboNav001CMiddle += $('.mbo-nav-001-middle').actual('outerHeight');
        }

        document.documentElement.style.setProperty( '--mbo-nav-001-ceyebrow', mboNav001CEyebrow + 'px' );
        document.documentElement.style.setProperty( '--mbo-nav-001-cmiddle', mboNav001CMiddle + 'px' );
      }

      // ---------------------------------------------------------------------
      // --------------------------- Fixed header ----------------------------

      // Set fixed header space.
      Drupal.behaviors.mbo_nav_001.fixedHeaderSpace = function() {
        var wasFixed = false;
        var wasReduced = false;
        if ($('#page > header > div.region-header').hasClass('fixed-position-show')) {
          $('#page > header > div.region-header').addClass('fixed-position-show');
          wasFixed = 'fixed-position-show';
        }
        if ($('#page > header > div.region-header').hasClass('fixed-position-hide')) {
          $('#page > header > div.region-header').addClass('fixed-position-hide');
          wasFixed = 'fixed-position-hide';
        }
        if ($('#page > header > div.region-header .mbo-nav-001-middle').hasClass('reduced-fixed')) {
          $('#page > header > div.region-header .mbo-nav-001-middle').removeClass('reduced-fixed');
          wasReduced = true;
        }

        var headerSpaceHeight = Math.ceil($('#page > header > div.region-header').outerHeight());
        $('#page > header').css('height', headerSpaceHeight);

        if ($('#page').hasClass('mbo_hero_001--mbo_nav_001--header-hybrid')) {
          if (!$('.mbf-page--section:first-of-type .layout--mbf-col-section.component--mbo_hero_001 .header-hybrid-space').length) {
            if ($('.mbf-page--section:first-of-type .layout--mbf-col-section.component--mbo_hero_001 .paragraph--type--mbo-hero-001').hasClass('mbo-hero-001--screen-height')) {
              $('.mbf-page--section:first-of-type .layout--mbf-col-section.component--mbo_hero_001').prepend('<div class="header-hybrid-space"></div>');
            }
          }

          $('.mbf-page--section:first-of-type .layout--mbf-col-section.component--mbo_hero_001').css('margin-top', 0 - headerSpaceHeight);
          $('.mbf-page--section:first-of-type .layout--mbf-col-section.component--mbo_hero_001').css('padding-top', headerSpaceHeight);
          $('.header-hybrid-space').css('height', headerSpaceHeight);
        }

        if (wasFixed !== false) {
          $('#page > header > div.region-header').addClass(wasFixed);
        }
        if (wasReduced !== false) {
          $('#page > header > div.region-header .mbo-nav-001-middle').addClass('reduced-fixed');
        }
      }

      // Check if device is tall enough.
      function fixedHeaderDisable() {
        if ($(window).outerHeight() < 600) {
          $('#page > header > div.region-header').removeClass('fixed-position-show').removeClass('fixed-position-hide').removeClass('no-transition');
          $('#page > header > div.region-header').css('position', 'absolute');
          return true;
        }
      }

      // Reset position and top.
      function fixedHeaderClear() {
        $('#page > header > div.region-header').css('position', '').css('top', '');
      }

      // Fix header out of view.
      function fixedHeaderHide() {
        fixedHeaderClear();

        // Check if device is tall enough.
        if (fixedHeaderDisable()) {
          return true;
        }

        // Don't do transition if header isn't currently showing.
        if (!$('#page > header > div.region-header').hasClass('fixed-position-show')) {
          $('#page > header > div.region-header').addClass('no-transition');
          setTimeout(function () {
            $('#page > header > div.region-header').removeClass('no-transition');
          }, 100);
        }

        // Update fixed classes.
        $('#page > header > div.region-header').removeClass('fixed-position-show').addClass('fixed-position-hide');
      }

      // Fixed header in view.
      function fixedHeaderShow() {
        fixedHeaderClear();

        // Check if device is tall enough.
        if (fixedHeaderDisable()) {
          return true;
        }

        // Update fixed classes.
        $('#page > header > div.region-header').removeClass('fixed-position-hide').addClass('fixed-position-show');
      }

      // Reset header back to top of page.
      function fixedHeaderReset() {
        fixedHeaderClear();

        // Check if device is tall enough.
        if (fixedHeaderDisable()) {
          return true;
        }

        // Remove fixed classes.
        $('#page > header > div.region-header').removeClass('fixed-position-show').removeClass('fixed-position-hide');
      }

      // Fixed header scrolling events.
      function fixedHeaderScrolling() {
        // Ignore if scrollLock in place or just removed.
        if ($('body').hasClass('scrollLock')) {
          return true;
        }

        // If the dropdowns are being used don't fix header.
        if ($('.mbo-nav-001-dropdowns').hasClass('open') || $('.field--name-field-o-nav-log-on-block').hasClass('open')) {
          return true;
        }

        // Update scroll position and set direction.
        var scrollPositionNew = $(window).scrollTop();
        var scrollDirection = 'down';
        if (scrollPositionNew < scrollPosition || scrollPositionNew == 0){
          scrollDirection = 'up';
        }
        scrollPosition = scrollPositionNew;

        // Set point to trigger.
        var scrollTrigger = Math.ceil($('#page > header').outerHeight()) + 200 + toolbarsHeightInView;

        // Fix header out of view.
        if (!$('#page > header > div.region-header').hasClass('fixed-position-hide') &&
          scrollDirection === 'down' && scrollPosition >= scrollTrigger) {
          fixedHeaderHide();
          return true;
        }

        // Fixed header in view.
        if (!$('#page > header > div.region-header').hasClass('fixed-position-show') &&
          scrollDirection === 'up' && scrollPosition >= scrollTrigger &&
          !$('body').hasClass('mbo-nav-001-prevent-header-popudown')) {
          fixedHeaderShow();
          return true;
        }

        // Reset header back to top of page.
        if (($('#page > header > div.region-header').hasClass('fixed-position-show') ||
             $('#page > header > div.region-header').hasClass('fixed-position-hide')) &&
          scrollDirection === 'up' && scrollPosition == 0) {
          fixedHeaderReset();
          return true;
        }
      }

      // =====================================================================
      // =====================================================================

      // ---------------------------------------------------------------------
      // ------------------- Keep track of toolbars height --------------------

      // Convert relative header to absolute, and set header space.
      $(document, context).once('mbo-nav-001-toolbars-height-onload').each( function() {
        toolbarsHeightInView = getToolbarsHeight();
      });
      $(window).once('mbo-nav-001-toolbars-height-resize').resize(function () {
        toolbarsHeightInView = getToolbarsHeight();
      });
      // Check if device is tall enough.
      $(window).once('mbo-nav-001-toolbars-height-scroll').scroll(function () {
        setTimeout(function () {
          toolbarsHeightInView = getToolbarsHeight();
        }, 500);
      });

      // ---------------------------------------------------------------------
      // ------------------------- Desktop dropdown --------------------------

      // Open and close dropdowns on non-touch devices.
      $('.mbo-nav-001-botttom ul.menu li a,.mbo-nav-001-botttom ul.menu li span').once('mbo-nav-001-botttom-main-mouseeneter').bind("mouseenter focus",function(){
        if (!$('body').hasClass('touch-enabled')) {
          clearTimeout(mouseOnNavTimer);

          mouseOnNavTop = true;
          mouseOnNavDropdown = false;
          openDropdown(this);
        }
      }).bind("mouseleave",function () {
        if (!$('body').hasClass('touch-enabled')) {
          mouseOnNavTimer = setTimeout(function () {
            mouseOnNavTop = false;
            if (!mouseOnNavDropdown) {
              closeDropdown(false);
            }
          }, 250);
        }
      });
      $('.mbo-nav-001-dropdowns').once('mbo-nav-001-dropdowns-mouseeneterleave').bind("mouseenter focusin",function(){
        clearTimeout(mouseOnNavTimer);

        mouseOnNavDropdown = true;
        mouseOnNavTop = false;
      }).bind("mouseleave focusout",function () {
        mouseOnNavTimer = setTimeout(function () {
          mouseOnNavDropdown = false;
          if (!mouseOnNavTop) {
            closeDropdown(false);
          }
        }, 250);
      });

      // Open and close dropdowns on touch devices.
      $('.mbo-nav-001-botttom ul.menu li a,.mbo-nav-001-botttom ul.menu li span').once('mbo-nav-001-botttom-main-click').click(function(e){
        clearTimeout(mouseOnNavTimer);

        if ($('body').hasClass('touch-enabled')) {
          if ($(this).closest('li').hasClass('open')) {
            closeDropdown(false);
          } else {
            openDropdown(this);
          }
          e.stopPropagation();
        }
      });
      $('.mbo-nav-001-dropdowns').once('mbo-nav-001-botttom-body-dropdowns-click').click(function(e){
        if ($('body').hasClass('touch-enabled')) {
          e.stopPropagation();
        }
      });
      $('body').once('mbo-nav-001-botttom-body-click').click(function(){
        if ($('body').hasClass('touch-enabled')) {
          if ($('.mbo-nav-001-dropdowns').hasClass('open')) {
            closeDropdown(false);
          }
        }
      });

      // Set dropdowns with 3rd levels.
      if ($('.mbo-nav-001-dropdowns').length) {
        $(document, context).once('mbo-nav-001-dropdown-3rd-levels').each( function() {
          $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns nav.menu--main > ul.menu > li').each(function(index, value) {
            if ($('ul.menu > li > ul.menu', $(value)).length) {
              $('> ul.menu', $(value)).addClass('column-levels');
            }
          });
        });
      }

      // Calculate sizes of dropdowns.
      if ($('.mbo-nav-001-dropdowns').length) {
        $(document, context).once('mbo-nav-001-dropdown-widths-onload').each(function () {
          calculateDropdownWidths();
        });
        $(window).once('mbo-nav-001-dropdown-widths-resize').resize(function () {
          calculateDropdownWidths();
          setTimeout(function (){
            calculateDropdownWidths();
          }, 500);
        });
      }
      $(document, context).once('mbo-nav-001-dropdown-widths-full-load').each(function () {
        window.addEventListener('load', function () {
          calculateDropdownWidths();
          setTimeout(function (){
            calculateDropdownWidths();
          }, 500);
        });
      });

      // Add dropdowns arrows & tabindex.
      if ($('.mbo-nav-001-dropdowns').length) {
        $(document, context).once('mbo-nav-001-dropdown-arrow').each(function () {
          $('.region-header ul.menu li span').attr('tabindex', '0');
          if (!$('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns .mbo-nav-001-dropdown-arrow').length) {
            $('.mbo-nav-001-dropdowns > .field--name-field-o-nav-main-menu-dropdowns').before('<span class="mbo-nav-001-dropdown-arrow"><span></span></span>');
          }
        });
      }

      // Auto close menu on resize.
      $(window).once('mbo-nav-001-menu-resize').resize(function () {
        closeDropdown(false);
      });

      // Global close function.
      $(document, context).once('mbo-nav-001-global-close').each(function () {
        Drupal.mbo_nav_001 = {};
        Drupal.mbo_nav_001.closeDropdown = function () {
          closeDropdown(false);
          closeMobileMenu();
        };
      });

      // Apply nicescroll to dropdowns.
      if (!$('body').hasClass('browser-ie')) {
        $('.mbo-nav-001-dropdowns nav.menu--main > ul.menu > li').once('mbo-nav-001-nice-scroll').niceScroll({
          cursoropacitymax: 0.5,
          cursorwidth: '7px',
          railpadding: { top: 0, right: 2, left: 0, bottom: 0 },
        });
      }

      // ---------------------------------------------------------------------
      // ---------------------------- Mobile nav -----------------------------

      // Mobile toggle burger/cross icon.
      if ($('.mbo-nav-001-middle-inner .field--name-field-o-nav-middle-menu a.mbo-nav-001-mobile-toggle-middle').length) {
        $('.mbo-nav-001-middle-inner .field--name-field-o-nav-middle-menu a.mbo-nav-001-mobile-toggle-middle').closest('li').addClass('mbo-nav-001-mobile-toggle-middle-li');
        $('.mbo-nav-001-middle-inner .field--name-field-o-nav-middle-menu a.mbo-nav-001-mobile-toggle-middle').replaceWith($('p.mbo-nav-001-mobile-toggle'));
      }
      $('.mbo-nav-001-mobile-toggle').once('mbo-nav-001-mobile-toggle-click').click( function() {
        if ($(this).hasClass('open')) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });

      // Add previous li items.
      if ($('.mbo-nav-001-mobile').length) {
        $(document, context).once('mbo-nav-001-mobile-previous-lis').each( function() {
          $('.field--name-field-o-nav-main-menu-mobile nav.menu--main > ul.menu > li').each(function(index, value) {
            if ($('ul', $(value)).length) {
              var levelTitle = $('> span', value).text().trim();

              $('ul.menu > li', $(value)).each(function (subindex, subvalue) {
                if ($('ul.menu', $(subvalue)).length) {
                  $('> ul.menu', $(subvalue)).prepend('<li class="menu-item p menu-previous"><span>' + levelTitle + '</span></li>');
                }
              });

              $('> ul.menu', $(value)).prepend('<li class="menu-item p menu-previous"><span>Menu</span></li>');
            }
          });
        });
      }

      // Add ULs wrappers for scrolling.
      if ($('.mbo-nav-001-mobile').length) {
        $('.mbo-nav-001-mobile ul.menu.menu-related').remove();
        $(document, context).once('mbo-nav-001-ul-wrappers').each( function() {
          $('.mbo-nav-001-mobile ul').wrap('<div class="ul-menu-wrapper"></div>');
        });
      }

      // Split mobile ul-menu-wrappers.
      if ($('.mbo-nav-001-mobile').length) {
        $(document, context).once('mbo-nav-001-ul-wrappers-splitting').each( function() {
          $('.field--name-field-o-nav-main-menu-mobile nav.menu--main > div.ul-menu-wrapper').addClass('top');
          $('.field--name-field-o-nav-main-menu-mobile nav.menu--main div.ul-menu-wrapper li.menu-item').each(function(index, value) {
            $(value).attr('data-menu',  index);
            $('> .ul-menu-wrapper', value).attr('data-menu', index);
          });

          $('.field--name-field-o-nav-main-menu-mobile nav.menu--main div.ul-menu-wrapper div.ul-menu-wrapper').each(function(index, value) {
            $('.field--name-field-o-nav-main-menu-mobile nav.menu--main').append(value);
          });
        });
      }

      // Auto close mobile menu on resize.
      $(window).once('mbo-nav-001-mobile-menu-resize').resize(function () {
        closeMobileMenu();
      });

      // Slide next level menu in.
      $('.field--name-field-o-nav-main-menu-mobile nav.menu--main ul.menu li:not(.menu-previous) span').once('mbo-nav-001-mobile-main-menu-click-next').click(function() {
        nextMobileMenu(this);
      });

      // Slide next level menu in.
      $('.field--name-field-o-nav-main-menu-mobile nav.menu--main ul.menu li.menu-previous span').once('mbo-nav-001-mobile-main-menu-click-prev').click(function() {
        prevMobileMenu(this);
      });

      // Add icons to menu items.
      if ($('.mbo-nav-001-mobile').length) {
        $(document, context).once('mbo-nav-001-mobile-icons').each(function () {
          $('.mbo-nav-001-mobile ul.menu li.menu-item a[data-icon],.mbo-nav-001-mobile ul.menu li.menu-item span[data-icon]').each(function(index, value) {
            $(value).addClass('menu-item-icon').addClass('icon--' +  $(value).data('icon')).prepend('<i></i>');
          });
        });
      }

      // ---------------------------------------------------------------------
      // --------------------------- Fixed header ----------------------------

      // Convert relative header to absolute, and set header space.
      $(document, context).once('mbo-nav-001-fixed-header-onload').each(function() {
        $('#page > header > div.region-header').css('position', 'absolute');
      });
      $(window).once('mbo-nav-001-header-space').resize(function () {
        Drupal.behaviors.mbo_nav_001.fixedHeaderSpace();
      });
      Drupal.behaviors.mbo_nav_001.fixedHeaderSpace();

      // Fix header scroll events.
      $(window).once('mbo-nav-001-fixed-header-scroll').scroll(function() {
        fixedHeaderScrolling();
      });

      // Check if device is tall enough.
      $(window).once('mbo-nav-001-fixed-header-disable').resize(function() {
        fixedHeaderDisable();
      });

      // ---------------------------------------------------------------------
      // ---------------------------- scrollLock -----------------------------

      // Global scrollLock callback function.
      $(document, context).once('mbo-nav-001-scrolllock-callback').each(function() {
        Drupal.mbo_nav_001_scrollLockCallback = {};
        Drupal.mbo_nav_001_scrollLockCallback.callback = function () {
          if ($('.mbo-nav-001-mobile-wrapper').hasClass('open')) {
            $.scrollLock(true);
          }
          toolbarsHeightInView = getToolbarsHeight();
          getFooterItemsHeight();
          getEyebrowMiddleItemsHeight();
        };
      });

      // Cart flyout open/close.
      $('.mbo-nav-001-middle a[href="/cart"],.mbo-nav-001-middle a[href="/basket"]').once('mbo-nav-001-cart-flyout').click(function(e) {
        if (typeof Drupal.cartFlyout !== 'undefined' && !$('.view-id-commerce_cart_form').length) {
          Drupal.cartFlyout.flyoutOffcanvasToggle();
          e.preventDefault();
        }
      });

      // Add cart count to menu item.
      if ($('.mbo-nav-001-middle a[href="/cart"]').length || $('.mbo-nav-001-middle a[href="/basket"]')) {
        var cartCount = $('.cart-block--offcanvas-cart-table--products .cart-block--offcanvas-cart-table--product').length;
        if (cartCount) {
          $('.mbo-nav-001-middle a[href="/cart"]').append('<span>' + cartCount + '</span>');
        } else {
          $('.mbo-nav-001-middle a[href="/cart"] span').remove();
        }
      }

    }
  }; //Drupal.behaviors.mbo_nav_001

})(jQuery, Drupal, drupalSettings);
